
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      leftMenuActive: false,
      rightMenuActive: false,
      hoverMenuActive: false,
    };
  },
  computed: {
    layoutContainerClass(): any[] {
      return [
        "layout-wrapper",
        {
          "left-layout-menu-active": this.leftMenuActive,
          "right-layout-menu-active": this.rightMenuActive,
        },
      ];
    },
  },
});
